import { CollapsibleTextDSProps } from './CollapsibleText.types';

export const isAutoWidth: (props: Partial<CollapsibleTextDSProps>) => boolean =
  ({ ellipsis, wrappingStyle }) => !ellipsis && wrappingStyle === 'single-line';
